import * as MatchStatus from 'customer-data-filters-ui/filterQueryFormat/MatchStatus';
import { useContext } from 'react';
import { useStrategy } from '../../hooks/useStrategy';
import ViewerConditionsGroupActions from './ViewerConditionsGroupActions';
import ViewerConditionsGroupConditions from './ViewerConditionsGroupConditions';
import FormattedMessage from 'I18n/components/FormattedMessage';
import H5 from 'UIComponents/elements/headings/H5';
import UIBox from 'UIComponents/layout/UIBox';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import ViewerConditionsGroupMatchStatusTag from './ViewerConditionsGroupMatchStatusTag';
import MatchStatusIcon from './MatchStatusIcon';
import styled from 'styled-components';
import { Box } from 'foundations-components/transitional/components/Box';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const GroupContainer = styled.div.attrs({
  'data-highlight-target': 'viewer-conditions-group',
  'data-test-id': 'viewer-conditions-group'
})(({
  useOnePanel,
  theme,
  defaultFormat,
  matchFail,
  matchPass
}) => {
  const divStyles = {
    position: 'relative',
    borderRadius: theme.borderRadius[100],
    zIndex: 1
  };
  if (defaultFormat) {
    divStyles.padding = theme.space[300];
    divStyles.backgroundColor = theme.color['fill-tertiary-default'];
  }
  if (useOnePanel) {
    if (matchFail) {
      divStyles.borderLeft = `4px solid ${theme.color['border-alert-default']}`;
      divStyles.paddingLeft = theme.space[200];
    } else if (matchPass) {
      divStyles.borderLeft = `4px solid ${theme.color['fill-positive-default']}`;
      divStyles.paddingLeft = theme.space[200];
    }
  } else {
    if (matchFail) {
      divStyles.backgroundColor = theme.color['fill-alert-subtle'];
    } else if (matchPass) {
      divStyles.backgroundColor = theme.color['fill-positive-subtle'];
    }
  }
  const beforeStyles = {};
  divStyles['&::before'] = beforeStyles;
  if (defaultFormat) {
    beforeStyles.content = '""';
    beforeStyles.position = 'absolute';
    beforeStyles.top = 0;
    beforeStyles.bottom = 0;
    beforeStyles.left = 0;
    beforeStyles.right = 0;
    beforeStyles.border = `1px solid ${theme.color['text-primary-disabled']}`;
    beforeStyles.borderRadius = theme.borderRadius[100];
    beforeStyles.zIndex = -1;
  }
  if (matchFail) {
    beforeStyles.borderColor = theme.color['border-alert-default'];
  } else if (matchPass) {
    beforeStyles.borderColor = theme.color['fill-positive-default'];
  }
  return divStyles;
});
const ViewerConditionsGroup = props => {
  const {
    logicGroup,
    logicGroupIndex,
    matchStatus: matchStatusFromProps
  } = props;
  const {
    isTestFiltersEnabled
  } = useStrategy();
  const {
    testFiltersStatus,
    props: {
      isAndGroup,
      layout,
      useNarrowPanelFormat,
      useOnePanel
    }
  } = useContext(SegmentationFiltersInstanceContext);
  let matchStatus = matchStatusFromProps;
  const logicGroupMatchStatusData = testFiltersStatus && testFiltersStatus.filtersData && testFiltersStatus.filtersData[logicGroupIndex];
  if (isTestFiltersEnabled) {
    matchStatus = logicGroupMatchStatusData && logicGroupMatchStatusData.status;
  }
  return /*#__PURE__*/_jsxs(GroupContainer, {
    defaultFormat: !useOnePanel && (layout === 'embedded' || !useNarrowPanelFormat),
    matchFail: matchStatus === MatchStatus.FAIL,
    matchPass: matchStatus === MatchStatus.PASS,
    useOnePanel: !!useOnePanel,
    children: [/*#__PURE__*/_jsxs(Flex, {
      flexDirection: "row",
      alignItems: "center",
      children: [useOnePanel && isTestFiltersEnabled && /*#__PURE__*/_jsx(Box, {
        paddingInlineStart: "100",
        paddingInlineEnd: "300",
        children: /*#__PURE__*/_jsx(MatchStatusIcon, {
          matchStatus: matchStatus
        })
      }), /*#__PURE__*/_jsxs("div", {
        style: {
          flexGrow: 1
        },
        children: [!isAndGroup && /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          justifyContent: "space-between",
          marginBlockStart: "-100",
          marginBlockEnd: matchStatus ? '0' : '100',
          minBlockSize: "32px",
          children: [/*#__PURE__*/_jsx(H5, {
            className: "m-y-0",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "newCustomerDataFilters.filtersViewer.groupHeading",
              options: {
                groupIndex: logicGroupIndex + 1
              }
            })
          }), /*#__PURE__*/_jsx(UIBox, {
            children: /*#__PURE__*/_jsx(ViewerConditionsGroupActions, {
              logicGroupIndex: logicGroupIndex
            })
          })]
        }), /*#__PURE__*/_jsx(ViewerConditionsGroupMatchStatusTag, {
          matchStatus: matchStatus,
          hideIcon: useOnePanel
        })]
      })]
    }), /*#__PURE__*/_jsx(ViewerConditionsGroupConditions, {
      logicGroup: logicGroup,
      logicGroupIndex: logicGroupIndex,
      logicGroupMatchStatusData: logicGroupMatchStatusData
    })]
  });
};
export default ViewerConditionsGroup;